const BRAND_LOGO_OPEN = '/brand/effektify-primary.svg'
const BRAND_LOGO_CLOSED = '/brand/effektify-symbol.svg'
const BRAND_LOGO_OPEN_INVERTED = '/brand/effektify-primary-inverted.svg'
const BRAND_LOGO_CLOSED_INVERTED = '/brand/effektify-symbol-inverted.svg'

export {
  BRAND_LOGO_OPEN,
  BRAND_LOGO_CLOSED,
  BRAND_LOGO_OPEN_INVERTED,
  BRAND_LOGO_CLOSED_INVERTED,
}
